import CalendarIcon from "./CalendarIcon";
import CheckIcon from "./CheckIcon";
import CompanyIcon from "./CompanyIcon";
import InfoIcon from "./InfoIcon";
import RightArrowIcon from "./RightArrowIcon";
import LeftArrowIcon from "./LeftArrowIcon";
import LogoIcon from "./LogoIcon";
import PenIcon from "./PenIcon";
import SettingIcon from "./SettingIcon";
import UserIcon from "./UserIcon";
import WatchIcon from "./WatchIcon";
import DeleteIcon from "./DeleteIcon";
import RefreshIcon from "./RefreshIcon";
import CloseIcon from "./CloseIcon";
import TopArrowIcon from "./TopArrowIcon";
import QuestionIcon from "./QuestionIcon";
import DashBoardIcon from "./DashBoardIcon";
import BookIcon from "./BookIcon";
import DownLoadIcon from "./DownLoadIcon";
import PeopleIcon from "./PeopleIcon";
import CopyIcon from "./CopyIcon";
import PlusCircleIcon from "./PlusCircleIcon";
import GripIcon from "./GripIcon";
import BoltIcon from "./BoltIcon";
import LinkIcon from "./LinkIcon";
import FilterIcon from "./FilterIcon";
import MeetingIllustIcon from "./MeetingIllustIcon";
import CalendarIllustIcon from "./CalendarIllustIcon";
import ConfirmAlarmIllustIcon from "./ConfirmAlarmIllustIcon";
import ChangeIcon from "./ChangeIcon";
import CircleMenuIcon from "./CircleMenuIcon";

export type IconProp = {
    className?: string;
    width?: string | number;
    height?: string | number;
    color?: string;
    hoverColor?: string;
    onClick?: () => void;
};

export type IconNames =
    | "info"
    | "check"
    | "logo"
    | "calendar"
    | "company"
    | "setting"
    | "watch"
    | "user"
    | "right-arrow"
    | "pen"
    | "left-arrow"
    | "delete"
    | "link"
    | "refresh"
    | "close"
    | "top-arrow"
    | "analytics"
    | "book"
    | "download"
    | "bolt"
    | "question"
    | "copy"
    | "meeting"
    | "grip"
    | "visitors"
    | "plus-circle"
    | "filter"
    | "meeting-illust"
    | "calendar-illust"
    | "confirm-alarm-illust"
    | "change"
    | "circle-menu";

export interface MileIconProps {
    className?: string;
    name: IconNames;
    width?: number;
    height?: number;
    color?: string;
    hoverColor?: string;
    onClick?: () => void;
}

export default function MileIcon({ className, name, width, height, color, hoverColor, onClick = () => {} }: MileIconProps) {
    switch (name) {
        case "info":
            return <InfoIcon width={width} height={height} color={color} />;
        case "check":
            return <CheckIcon width={width} height={height} color={color} />;
        case "logo":
            return <LogoIcon width={width} height={height} color={color} />;
        case "calendar":
            return <CalendarIcon width={width} height={height} color={color} />;
        case "meeting":
            return <CalendarIcon width={width} height={height} color={color} />;
        case "company":
            return <CompanyIcon width={width} height={height} color={color} />;
        case "setting":
            return <SettingIcon width={width} height={height} color={color} hoverColor={hoverColor} />;
        case "watch":
            return <WatchIcon width={width} height={height} color={color} onClick={onClick} />;
        case "user":
            return <UserIcon width={width} height={height} color={color} />;
        case "right-arrow":
            return <RightArrowIcon width={width} height={height} color={color} />;
        case "left-arrow":
            return <LeftArrowIcon width={width} height={height} color={color} onClick={onClick} />;
        case "pen":
            return <PenIcon width={width} height={height} color={color} onClick={onClick} hoverColor={hoverColor} />;
        case "delete":
            return <DeleteIcon width={width} height={height} color={color} onClick={onClick} hoverColor={hoverColor} />;
        case "refresh":
            return <RefreshIcon width={width} height={height} color={color} />;
        case "close":
            return <CloseIcon width={width} height={height} color={color} onClick={onClick} />;
        case "top-arrow":
            return <TopArrowIcon className={className} width={width} height={height} color={color} onClick={onClick} />;
        case "question":
            return <QuestionIcon width={width} height={height} color={color} />;
        case "analytics":
            return <DashBoardIcon width={width} height={height} color={color} />;
        case "book":
            return <BookIcon width={width} height={height} color={color} />;
        case "download":
            return <DownLoadIcon width={width} height={height} color={color} />;
        case "visitors":
            return <PeopleIcon width={width} height={height} color={color} />;
        case "copy":
            return <CopyIcon width={width} height={height} color={color} />;
        case "plus-circle":
            return <PlusCircleIcon width={width} height={height} color={color} />;
        case "grip":
            return <GripIcon width={width} height={height} color={color} hoverColor={hoverColor} />;
        case "bolt":
            return <BoltIcon width={width} height={height} color={color} />;
        case "link":
            return <LinkIcon width={width} height={height} color={color} />;
        case "filter":
            return <FilterIcon className={className} width={width} height={height} color={color} />;
        case "meeting-illust":
            return <MeetingIllustIcon className={className} width={width} height={height} color={color} />;
        case "calendar-illust":
            return <CalendarIllustIcon className={className} width={width} height={height} color={color} />;
        case "confirm-alarm-illust":
            return <ConfirmAlarmIllustIcon className={className} width={width} height={height} color={color} />;
        case "change":
            return <ChangeIcon width={width} height={height} color={color} />;
        case "circle-menu":
            return <CircleMenuIcon width={width} height={height} color={color} />;
    }
}
